import { NgModule } from '@angular/core';
import { IconComponent } from './icon/icon.component';

@NgModule({
  declarations: [IconComponent],
  imports: [
  ],
  exports: [IconComponent]
})
export class AngularIconMorphingModule { }
